export const initialState = {
  blogCategoryReducer: { currentCategory: 'All' },
  searchTermReducer: { searchTerm: '' },
  blogPostsReducer: { blogPosts: [] },
};
